import React from 'react'
import { connect } from 'react-redux'
import ProductActions from '../../Redux/ProductRedux'
import FilesActions from '../../Redux/FilesRedux'
import FileUploader from '../FileUploader'
import { includes } from 'lodash'
import { currentBranch } from '../../Utils/PrivilegeUtils'

class FormCreate extends React.Component {
  constructor (props) {
    super(props)

    const currencyCode = (branch = currentBranch()) => {
      switch (branch) {
        case 'ID':
          return 'IDR'
        case 'PH':
          return 'PHP'
        default:
          return null
      }
    }

    this.CCSelector = [
      { value: 'IDR', label: 'IDR', restriction: ['PH'] },
      // { value: 'SGD', label: 'SGD', restriction: ['PH'] },
      { value: 'USD', label: 'USD', restriction: ['PH'] },
      { value: 'PHP', label: 'PHP' }
    ].filter((option) => { return (!includes(option.restriction, currentBranch())) })

    this.state = {
      form: {
        title: '',
        description: '',
        description_ind: '',
        description_eng: '',
        short_desc_id: '',
        short_desc_en: '',
        meta_description: '',
        meta_title: '',
        normal_price: 0,
        price: 0,
        currency_code: currencyCode(),
        image_file: '',
        product_type: 'modem',
        status: 'active',
        use_dynamic_price: 0,
        divisor: 1,
        use_coupon: '1',
        quota: '',
        short_code: '',
        iso_code: currentBranch(),
        details: {
          country_id: ''
        }
      },
      file: null,
      uploaded: false
    }
  }

  componentDidMount = () => {
    this.props.resetFile()
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.files.data) {
      let form = { ...this.state.form }
      form.image_file = newProps.files.data.upload[0].filename
      this.setState({ form })
    }
  }

  _fileSelect = (event) => {
    const file = event.target
    this.setState({ file })
  }

  _upload = (event) => {
    event.preventDefault()
    let data = new FormData()
    data.append('files', this.state.file.files[0])
    data.append('type', 'product')
    data.append('product_type', this.state.form.product_type)

    this.props.upload(data)
    this.setState({ uploaded: true })
  }

  _fileUploaded = (filename, field) => {
    let form = { ...this.state.form }
    form[field] = filename
    this.setState({ form })
  }

  _inputChange = (event, field) => {
    let form = { ...this.state.form }
    let val = event.target.value
    // 'deprecate' the validation below
    // if (event.target.type === 'number') {
    //   val = parseFloat(val)
    // }

    form[field] = val
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = { ...this.state.form }
    if (currentBranch() === 'PH') {
      form.description_ind = form.description_eng
    }
    this.props.submit(form)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <section className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Create Product</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Title</label>
            </div>
            <div className='col-9'>
              <input type='text' required placeholder='Product Title' className='form-control' value={this.state.form.title} onChange={(event) => this._inputChange(event, 'title')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Key Passpod</label>
            </div>
            <div className='col-9'>
              <textarea placeholder='Key Passpod' required className='form-control' value={this.state.form.description} onChange={(event) => this._inputChange(event, 'description')} />
            </div>
          </div>
          {
            currentBranch() !== 'PH' &&
            <div className='form-group row'>
              <div className='col-3'>
                <label className='control-label'>Description (ID)</label>
              </div>
              <div className='col-9'>
                <textarea placeholder='ID Product Description' className='form-control' value={this.state.form.description_ind} onChange={(event) => this._inputChange(event, 'description_ind')} />
              </div>
            </div>
          }
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Description (EN)</label>
            </div>
            <div className='col-9'>
              <textarea placeholder='EN Product Description' className='form-control' value={this.state.form.description_eng} onChange={(event) => this._inputChange(event, 'description_eng')} />
            </div>
          </div>
          {
            currentBranch() !== 'PH' &&
            <div className='form-group row'>
              <div className='col-3'>
                <label className='control-label'>Short Description (ID)</label>
              </div>
              <div className='col-9'>
                <textarea placeholder='' className='form-control' value={this.state.form.short_desc_id} onChange={(event) => this._inputChange(event, 'short_desc_id')} />
              </div>
            </div>
          }
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Short Description (EN)</label>
            </div>
            <div className='col-9'>
              <textarea placeholder='' className='form-control' value={this.state.form.short_desc_en} onChange={(event) => this._inputChange(event, 'short_desc_en')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Meta-title</label>
            </div>
            <div className='col-9'>
              <textarea placeholder='Meta-title' className='form-control' value={this.state.form.meta_title} onChange={(event) => this._inputChange(event, 'meta_title')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Meta-description</label>
            </div>
            <div className='col-9'>
              <textarea placeholder='Meta-description' className='form-control' value={this.state.form.meta_description} onChange={(event) => this._inputChange(event, 'meta_description')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Currency Code</label>
            </div>
            <div className='col-9'>
              <select className='form-control' required value={this.state.form.currency_code} onChange={(event) => this._inputChange(event, 'currency_code')}>
                { this.CCSelector.map((item, i) => (<option key={i} value={item.value}>{item.label}</option>)) }
              </select>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Normal Price</label>
            </div>
            <div className='col-9'>
              <input type='number' min={0} className='form-control' required value={this.state.form.normal_price} onChange={(event) => this._inputChange(event, 'normal_price')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Final Price</label>
            </div>
            <div className='col-9'>
              <input type='number' min={0} className='form-control' required value={this.state.form.price} onChange={(event) => this._inputChange(event, 'price')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Product Type</label>
            </div>
            <div className='col-9'>
              <select className='form-control' required value={this.state.form.product_type} onChange={(event) => this._inputChange(event, 'product_type')}>
                <option value='modem'>Modem</option>
              </select>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Status</label>
            </div>
            <div className='col-9'>
              <select className='form-control' required value={this.state.form.status} onChange={(event) => this._inputChange(event, 'status')}>
                <option value='active'>Active</option>
                <option value='inactive'>Inactive</option>
              </select>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Dynamic Price</label>
            </div>
            <div className='col-9'>
              <select className='form-control' required value={this.state.form.use_dynamic_price} onChange={(event) => this._inputChange(event, 'use_dynamic_price')}>
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
              </select>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Divisor</label>
            </div>
            <div className='col-9'>
              <input type='number' className='form-control' min='1' required value={this.state.form.divisor} onChange={(event) => this._inputChange(event, 'divisor')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Allow Coupon</label>
            </div>
            <div className='col-9'>
              <select className='form-control' required value={this.state.form.use_coupon} onChange={(event) => this._inputChange(event, 'use_coupon')}>
                <option value='1'>Allowed</option>
                <option value='0'>Not Allowed</option>
              </select>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Quota</label>
            </div>
            <div className='col-9'>
              <input placeholder='Product quota' type='text' className='form-control' value={this.state.form.quota} onChange={(event) => this._inputChange(event, 'quota')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Short Code</label>
            </div>
            <div className='col-9'>
              <input placeholder='Short product code (3 to 4 letters)' type='text' minLength={3} maxLength={4} className='form-control' value={this.state.form.short_code} onChange={(event) => this._inputChange(event, 'short_code')} />
            </div>
          </div>
          <div className='form-group'>
            <div className='row'>
              <div className='col-3'>
                <label htmlFor='image' className='control-label'>Image File (<span className='text-orange'>270x160</span>)</label>
              </div>
              <div className='col-9'>
                <FileUploader setting={{ type: 'product', product_type: this.state.form.product_type }} onUploaded={(filename) => this._fileUploaded(filename, 'image_file')} />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' disabled={!this.state.form.image_file} className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  files: state.files
})

const dispatchToProps = (dispatch) => ({
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  resetFile: () => dispatch(FilesActions.filesUploadReset()),
  submit: (data) => dispatch(ProductActions.productCreateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(FormCreate)



// WEBPACK FOOTER //
// ./src/Containers/Product/FormCreate.js